import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useUserPreferences } from "../contexts/UserPreferencesContext";
import { translations } from "../config/translations";

const AuthRedirect = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { language } = useUserPreferences();
  const t = translations[language];
  const [newPassword, setNewPassword] = useState("");
  const [showPasswordChange, setShowPasswordChange] = useState(false);

  useEffect(() => {
    const handleAuth = async () => {
      try {
        // Jeśli wciąż trwa ładowanie, czekamy
        if (auth.isLoading) {
          return;
        }

        // Logowanie stanu dla debugowania
        console.log("Auth state:", {
          isLoading: auth.isLoading,
          isAuthenticated: auth.isAuthenticated,
          user: auth.user,
          status: auth.user?.status,
        });

        // Sprawdź czy użytkownik musi zmienić hasło
        if (auth.user?.status === "FORCE_CHANGE_PASSWORD") {
          setShowPasswordChange(true);
          return;
        }

        // Jeśli nie jesteśmy uwierzytelnieni, najpierw wykonaj callback
        if (!auth.isAuthenticated) {
          await auth.signinCallback();
          return;
        }

        // Po pomyślnym uwierzytelnieniu
        if (auth.user && auth.isAuthenticated) {
          // Sprawdź grupy użytkownika
          const groups = auth.user?.profile["cognito:groups"] || [];
          const isAdmin = groups.includes("Admins");

          console.log("User groups:", groups);
          console.log("Is admin:", isAdmin);

          // Przekieruj na podstawie roli
          navigate(isAdmin ? "/admin-panel" : "/user-panel", { replace: true });
        }
      } catch (error) {
        console.error("Auth error:", error);
        navigate("/", { replace: true });
      }
    };

    handleAuth();
  }, [
    auth.isLoading,
    auth.isAuthenticated,
    auth.user,
    auth.signinCallback,
    navigate,
  ]);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    try {
      await auth.completeNewPasswordChallenge(newPassword);
      setShowPasswordChange(false);
      const isAdmin = (auth.user?.profile["cognito:groups"] || []).includes(
        "Admins"
      );
      navigate(isAdmin ? "/admin-panel" : "/user-panel", { replace: true });
    } catch (error) {
      console.error("Password change error:", error);
      // Tutaj możesz dodać obsługę błędów, np. wyświetlenie komunikatu
    }
  };

  if (showPasswordChange) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="p-6 bg-white rounded-lg shadow-md max-w-md w-full">
          <h2 className="text-xl font-bold mb-4">
            {t.changePasswordRequired || "Change Password Required"}
          </h2>
          <form onSubmit={handlePasswordChange}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t.newPassword || "New Password"}:
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full p-2 border rounded"
                required
                minLength={8}
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                title="Password must contain at least 8 characters, including uppercase and lowercase letters, numbers and special characters"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
            >
              {t.changePassword || "Change Password"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Pokaż ładowanie podczas przetwarzania
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-t-blue-500 border-blue-200 mb-4"></div>
        <p className="text-gray-600 dark:text-gray-300">
          {t.authenticating || "Authenticating..."}
        </p>
      </div>
    </div>
  );
};

export default AuthRedirect;
